import React, {FC} from 'react';
import {connect} from "react-redux";
import {fetchMixCompilation, setCurrentCompilations} from "../../modules/Main";
import CompilationsList from "../../components/Main/CompilationsList";
import {getAuthorCompilations, getHookahCompilations, getOurCompilations} from "../../services/selectionSelector";

interface IListMixesCompilationPage {
    currentCompilation: string,
    setCurrentCompilations: any,
    fetchMixCompilation: any,
    indexCompilations: number,
    ourCompilations: any,
    hookahCompilations: any,
    authorCompilations: any,
}

const ListMixesCompilationPage: FC<IListMixesCompilationPage> = ({
                                                                     currentCompilation,
                                                                     setCurrentCompilations,
                                                                     fetchMixCompilation,
                                                                     indexCompilations,
                                                                     ourCompilations,
                                                                     hookahCompilations,
                                                                     authorCompilations,
                                                                 }) => {

    const sortCompilations = [ourCompilations, hookahCompilations, authorCompilations];
    return (
        <CompilationsList
            title={currentCompilation[0]}
            imageUrl={currentCompilation[1]}
            setCurrentCompilations={setCurrentCompilations}
            fetchMixCompilation={fetchMixCompilation}
            compilations={sortCompilations[indexCompilations]}
        />
    )
};

const mapStateToProps = (state: any) => ({
    currentCompilation: state.main.currentCompilation,
    indexCompilations: state.main.selectedIndexCompilations,
    ourCompilations: getOurCompilations(state),
    hookahCompilations: getHookahCompilations(state),
    authorCompilations: getAuthorCompilations(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    fetchMixCompilation: (id: number) => dispatch(fetchMixCompilation(id)),
    setCurrentCompilations: (id: number, isGroupCard: number) => dispatch(setCurrentCompilations(id, isGroupCard)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ListMixesCompilationPage);

